export const LEADERBOARD_LOAD_MORE_COPY = {
  SHOW_MORE: 'Show more',
  LOADING: 'Loading…',
} as const;

/** Stable testID for the "Show more" button (play tests + Vitest). */
export const LEADERBOARD_LOAD_MORE_TEST_ID = 'leaderboard-load-more';
